// extracted by mini-css-extract-plugin
export default {"item":"NavTab_item__w-wPD"};